import { Injectable, Injector } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { PermissionDeniedMessage } from '../models/api/errors/permission-denied-error.interface';
import { PermissionDeniedModalComponent } from '../../shared/components/permission-denied-modal/permission-denied-modal.component';

@Injectable({
  providedIn: 'root'
})
export class PermissionDeniedModalService {
  private dialogService: DialogService | null = null;
  private isModalOpen = false;

  constructor(private injector: Injector) {}

  showPermissionDeniedModal(permissionData: PermissionDeniedMessage): void {
    if (this.isModalOpen) {
      return;
    }

    if (!this.dialogService) {
      this.dialogService = this.injector.get(DialogService);
    }

    this.isModalOpen = true;

    const dialogRef = this.dialogService.open(PermissionDeniedModalComponent, {
      width: '500px',
      showHeader: false,
      dismissableMask: true,
      styleClass: 'permission-denied-dialog',
      data: {
        permissionData
      }
    });

    dialogRef.onClose.subscribe(() => {
      this.isModalOpen = false;
    });
  }
}
